export const CREDENTIAL_NAME_MAX_LENGTH = 23;

export const buildCredentialName = (name = "", lastName = "") => {
  if (!name.trim() || !lastName.trim()) {
    return "";
  }

  return `${name} ${lastName}`.trim().slice(0, CREDENTIAL_NAME_MAX_LENGTH);
}

export const allowCredentialNameToReceiveValue = (
  name = "",
  lastName = "",
  credentialName = ""
) => {
  if (!credentialName.trim()) {
    return true;
  }

  return buildCredentialName(name, lastName) === credentialName.trim();
}
